export default function Count() {
  return (
    <div className="w-full">
      backgroundImage: `url(${require("./Count.jpg")})`
    </div>
    // <img
    //   src={require("./Count.jpg")}
    //   className="mt-5 h-[65vh] bg-red-500"
    //   alt="logo"
    // />
  );
}
